import { GlButton, GlLoadingIcon } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { getIdFromGraphQLId } from '~/graphql_shared/utils';
import { __, n__, sprintf } from '~/locale';
import UserAvatarImage from '../../../vue_shared/components/user_avatar/user_avatar_image.vue?vue3';
export default {
    name: 'ParticipantsList',
    components: {
        GlButton,
        GlLoadingIcon,
        UserAvatarImage
    },
    props: {
        loading: {
            type: Boolean,
            required: false,
            default: false
        },
        participants: {
            type: Array,
            required: false,
            default: ()=>[]
        },
        participantCount: {
            type: Number,
            required: false,
            default: undefined
        },
        numberOfLessParticipants: {
            type: Number,
            required: false,
            default: 8
        },
        showParticipantLabel: {
            type: Boolean,
            required: false,
            default: true
        },
        lazy: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    data () {
        return {
            isShowingMoreParticipants: false
        };
    },
    computed: {
        lessParticipants () {
            return this.participants.slice(0, this.numberOfLessParticipants);
        },
        visibleParticipants () {
            return this.isShowingMoreParticipants ? this.participants : this.lessParticipants;
        },
        hasMoreParticipants () {
            return this.participantCountCalculated > this.numberOfLessParticipants;
        },
        moreParticipantCount () {
            return this.participantCountCalculated - this.numberOfLessParticipants;
        },
        moreParticipantsLabel () {
            return this.isShowingMoreParticipants ? __('- show less') : sprintf(__('+ %{moreCount} more'), {
                moreCount: this.moreParticipantCount
            });
        },
        participantLabel () {
            return sprintf(n__('%{count} Participant', '%{count} Participants', this.participantCountCalculated), {
                count: this.loading ? '' : this.participantCountCalculated
            });
        },
        participantCountCalculated () {
            return Math.max(this.participants.length, this.participantCount || 0);
        }
    },
    methods: {
        toggleMoreParticipants () {
            this.isShowingMoreParticipants = !this.isShowingMoreParticipants;
        },
        getParticipantId (participantId) {
            return getIdFromGraphQLId(participantId);
        }
    }
};
